import React, { useState, useEffect, useContext } from 'react';

import 'animate.css';
import "../assets/css/website.css";

import Logo from "../assets/img/logo_cabecera.png";
import LogoFooter from "../assets/img/Home/logo_alma_footer.png";
import InstagramIcon from '@mui/icons-material/Instagram';
import FacebookSharpIcon from '@mui/icons-material/FacebookSharp';
import TwitterIcon from '@mui/icons-material/Twitter';

import iosDown from "../assets/img/Home/descargar_appstore.png";
import playDown from "../assets/img/Home/descargar_playstore.png";

import sanitizeUrl from '../utils/sanitizeUrl';
import { CartContext } from '../context/CartContext';

const CheckoutLayout = ({ children }) => {
    const [menuActive, setMenuActive] = useState(false);
    const {
        cartItems,
    } = useContext(CartContext);

    const [width, setWidth] = useState(window.innerWidth);

    const handleResize = () => {
        setWidth(window.innerWidth);
    };

    useEffect(() => {
        window.addEventListener('resize', handleResize);
        return () => {
            window.removeEventListener('resize', handleResize);
        };
    }, []);

    return (
        <>
            <header id='header' className='py-3 bg-white'>
                <div className='container d-flex justify-content-between align-items-center'>
                    <div className='logo pe-5'>
                        <a href="/">
                            <img src={Logo} alt="Logo" />
                        </a>
                    </div>
                    
                    
                    <div className='box-pago-seguro d-flex'>
                        <img src="#" alt="" />
                        <p className='m-0'>
                            <strong>
                                Pago 100% seguro
                            </strong>
                            <br />
                            Cifrado SSL y 3D Secure
                        </p>
                    </div>
                </div>
            </header>

            <main>{children}</main>

            <footer className="footer d-none">
                <div className="container py-5 border-bottom d-flex justify-content-center align-items-center flex-md-row flex-column">
                    <div className="px-md-4 px-2 text-md-left text-center">
                        <h3>Descarga la App</h3>
                        <p>Ahora puedes tener un universo de productos únicos en tú celular. Disponible para iOS y Android</p>
                    </div>
                    <div className="px-md-4 px-2 d-flex flex-column">
                        <a className="btn btn-down-app" href="/">
                            <img width="130" src={iosDown} alt="IosLogo" />
                        </a>
                        <a className="btn btn-down-app" href="/">
                            <img width="130" src={playDown} alt="PlayLogo" />
                        </a>
                    </div>
                </div>
                <div className="container flex-column flex-md-row pt-5 pb-4 d-flex justify-content-center align-items-center">
                    <div className="p-4 border-md-right text-center">
                        <div className="logo-footer">
                            <a href="/">
                                <img width="133" src={LogoFooter} alt="logo" />
                            </a>
                        </div>
                        <nav className="nav-rs-footer">
                            <ul>
                                <li>
                                    <a href="/">
                                        <InstagramIcon />
                                    </a>
                                </li>
                                <li>
                                    <a href="/">
                                        <FacebookSharpIcon />
                                    </a>
                                </li>
                                <li>
                                    <a href="/">
                                        <TwitterIcon />
                                    </a>
                                </li>
                            </ul>
                        </nav>
                    </div>
                    <div className="p-4">
                        <nav className="nav-footer">
                            <ul>
                                <li>
                                    <a href="/">
                                        Para empresas 
                                    </a>
                                </li>
                                <li>
                                    <a href="/">
                                        Mi cuenta 
                                    </a>
                                </li>
                                <li>
                                    <a href="/">
                                        Términos y Condiciones 
                                    </a>
                                </li>
                                <li>
                                    <a href="/">
                                        Preguntas frecuentes 
                                    </a>
                                </li>
                                <li>
                                    <a href="/">
                                        Contáctanos 
                                    </a>
                                </li>
                                <li>
                                    <a href="/">
                                        Rastrea tu pedido
                                    </a>
                                </li>
                            </ul>
                        </nav>
                    </div>
                </div>
                <div className="copyright container d-flex align-items-center justify-content-center">
                    <p className="w-100 text-center mb-0 py-4">
                        Copyright © 2020 Todos los derechos reservados
                    </p>
                </div>
            </footer>
        </>
    )
};

export default CheckoutLayout;
